import type { WritableAtom } from 'nanostores';
// @ts-expect-error Cannot find name '__IS_ASTRO__'.
const isAstro = typeof __IS_ASTRO__ !== 'undefined' ? __IS_ASTRO__ : false;

export function createUniversalStore<T>(key: string, store: WritableAtom<T>): WritableAtom<T> {
    if (isAstro) {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const { shared } = require('@it-astro:request-nanostores');

        // @ts-expect-error Untyped function calls may not accept type arguments
        return shared<T>(key, store);
    }

    return store;
}
